if (!customElements.get('ked-read-more')) {
  customElements.define(
    'ked-read-more',
    class KedReadMore extends HTMLElement {
      connectedCallback() {
        const body = this.querySelector('.ked-read-more__body');
        const toggle = this.querySelector('.ked-read-more__toggle');
        if (!body || !toggle) return;

        // Short texts fit without collapsing, so they show in full with no button.
        if (body.scrollHeight <= body.clientHeight + 40) {
          this.classList.add('is-short');
          return;
        }

        toggle.addEventListener('click', () => {
          const open = this.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open);
          if (!open) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }
    }
  );
}
